import { animate, style, transition, trigger } from '@angular/animations';

const collapsedStyle = style({ opacity: 0, height: 0 });
const expandedStyle = style({ opacity: 1, height: '*' });

// This uses the special :enter and :leave states to animate something being added or removed from the DOM.
// This can be paired with an *ngIf directive.
export const expandCollapseAnimation = trigger('expandCollapse', [
    transition(':enter', [
        collapsedStyle,
        animate('500ms 100ms ease-in-out', expandedStyle),
    ]),
    transition(':leave', [
        expandedStyle,
        animate('500ms 100ms ease-in-out', collapsedStyle)
    ])
]);
